/**
 * Fetches active curated lists for a map (public endpoint).
 */

import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useAvailableCuratedLists(
  orgSlug: string | undefined,
  mapSlug: string | undefined,
  enabled = true
) {
  return useQuery({
    queryKey: ["curated-lists-public", orgSlug, mapSlug],
    queryFn: async () => {
      if (!orgSlug || !mapSlug) throw new Error("Missing params");
      const res = await api.maps.lists[":orgSlug"][":mapSlug"].$get({
        param: { orgSlug, mapSlug },
      });
      if (!res.ok) return [];
      const data = await res.json();
      return data.lists;
    },
    enabled: !!orgSlug && !!mapSlug && enabled,
    staleTime: 5 * 60 * 1000,
  });
}
